// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'fast-food';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M4.75 12.72 6.344 1.031l3.187.531M8.469 14.845h7.437v1.062a1.063 1.063 0 0 1-1.062 1.063H9.53a1.063 1.063 0 0 1-1.062-1.063zm2.125-5.313h3.187a2.125 2.125 0 0 1 2.125 2.125v1.063H8.47v-1.063a2.125 2.125 0 0 1 2.125-2.125z' />
    <path d='M5.281 16.97H2.625L1.031 5.281h9.031l-.259 1.9M8.469 12.72h7.437s1.063 0 1.063 1.062c0 0 0 1.063-1.063 1.063H8.47s-1.063 0-1.063-1.063c0 0 0-1.063 1.063-1.063z' />
  </g>
);

export const viewBox = '0 0 18 18';
